























































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IWarehouse from '@/store/models/IWarehouse';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { uniq } from "lodash";
import moment from 'moment';
import IListPalletType from '@/store/models/IListPalletType';
import IAuthentication from '@/store/models/IAuthentication';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
interface ExportHeader {
    text: string;
    value: string;
}
@Component({
    components: {
        Snackbar,
        FilterMenu
    }
})
export default class StockSelector extends Vue {
    @Prop({ type: Array, required: true })
    WarehouseList !: IWarehouse[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    StockList !: IStock[];
    @Prop({ type: Array, required: true })
    StockListNoModifications !: IStock[];
    @Prop({ type: Array, required: true })
    PalletTypeList !: IListPalletType[];
    @Prop({ type: Boolean, default: false })
    IsShared !: boolean;
    @Prop({ type: Boolean, default: false })
    ShowStockCustom !: boolean;
    @Prop({ type: Boolean, default: false })
    ScannerActive !: boolean;

    languageText: string = "";
    activeSelectAll : boolean = false;
    activeDeselectAll : boolean = false;
    searchStock: string = "";
    selectedStockList : IStock[] = [];
    selectedStockListOrderBySelection : IStock[] = [];
    selectedStockListSelectAll : IStock[] = [];
    warehouseSelected : IWarehouse[] = [];
    companySourceNamesFilter : string[] = [];
    inboundCodeFilter : string[] = [];
    inboundCodeDestinationFilter : string[] = [];
    customerFilter : string[] = [];
    goodFilter : string[] = [];
    locationFilter : string[] = [];
    palletFilter : string[] = [];
    warehouseNameFilter : string[] = [];
    bestBeforeDateFilter : Date[] = [];
    goodCodeFilter: string[] = [];
    languageFilter: string[] = [];
    dateInFilter : Date[] = [];
    groupByActive : boolean = false;
    stockError: string[] = [];
    location: string = "";
    selectedPalletType: IListPalletType = {} as IListPalletType;
    selectedPalletTypeName: string = "";
    dialog: boolean = false;
    dialogPalletType: boolean = false;
    dialogPrinting: boolean = false;
    startDateReport: string = new Date().toISOString().substr(0, 10);
    menu2: boolean = false;
    endDateReport: string = new Date().toISOString().substr(0, 10);
    menu3: boolean = false;
    selectedFormatToPrint : string = "excel";
    palletIdFilter: string[] = [];
    editingLocationId: string = "";
    editingLocationValue: string = "";
    tableOptions: any = {
        sortBy: [],
        sortDesc: []
    };
    tableSortedItems: IStock[] = [];

    get headersCustom(): any {
        const baseHeaders = [
            { text: 'Good', align: 'start', value: 'goodName' },
            { text: 'Good Code', align: 'start', value: 'goodCode' },
            { text: 'Dossier Number Source', value: 'codeInbounds' },
            { text: 'Dossier Number Destination', value: 'codeDestination' },
            { text: 'Company Source', value: 'companySourceName' },
            { text: 'Customer', value: 'customerName' },
            { text: 'Warehouse', value: 'warehouseName' },
            { text: 'Pallet type', value: 'listPalletName' }
        ];

        if (this.groupByActive) {
            baseHeaders.push(
                { text: 'Pallet amount', value: 'palletsAmount' },
                { text: 'Total cases', value: 'totalCases' },
                { text: 'Goods per case', value: 'goodsPerCase' },
                { text: 'Location', value: 'location' },
                { text: 'BestBeforeDate', value: 'bestBeforeDate' }
            );

            if (this.ShowStockCustom) {
                baseHeaders.push({ text: 'Weight', value: 'weight' });
            }

            baseHeaders.push({ text: 'Date In', value: 'dateIn' });
        } else {
            baseHeaders.push(
                { text: 'Pallet id', value: 'idPallet' },
                { text: 'Total cases', value: 'totalCases' },
                { text: 'Goods per case', value: 'goodsPerCase' },
                { text: 'Location', value: 'location' },
                { text: 'BestBeforeDate', value: 'bestBeforeDate' }
            );

            if (this.ShowStockCustom) {
                baseHeaders.push({ text: 'Weight', value: 'weight' });
            }

            baseHeaders.push({ text: 'Date In', value: 'dateIn' });
        }

        // 🔹 Mostrar columnas finales según ShowStockCustom y ScannerActive
        if (!this.ShowStockCustom) {
            const finalCols = [
                { text: 'Reference dossier number', value: 'referenceInboundCode' },
                // 👇 Si ScannerActive = true, mostramos idPalletCustomer y ocultamos Language
                ...(this.ScannerActive
                    ? [{ text: this.languageText, value: 'idPalletCustomer' }]
                    : [{ text: this.languageText || 'Language', value: 'language' }]),
                { text: 'Douana document', value: 'documentation' },
                { text: 'Is transformed', value: 'isTransformed' }
            ];
            baseHeaders.push(...finalCols);
        } else {
            const finalCols = [
                ...(this.ScannerActive
                    ? [{ text: this.languageText, value: 'idPalletCustomer' }]
                    : [{ text: this.languageText || 'Language', value: 'language' }]),
                { text: 'Douana document', value: 'documentation' }
            ];
            baseHeaders.push(...finalCols);
        }

        return baseHeaders;
    }

    openEditorLocation(item: IStock) {
        this.editingLocationId = item.id;
        this.editingLocationValue = item.location || "";
    }

    onOptionsUpdate(options: any) {
        this.tableOptions = options;
    }
    
    async mounted() {
        await this.SetLanguageText();
    }

    buildExportData(sortedList: IStock[]) {
        // Tipamos los headers
        const visibleHeaders: ExportHeader[] = this.headersCustom.map((h: any) => {
            return {
                text: h.text as string,
                value: h.value as string
            };
        });

        // Construir filas según lo visible en la tabla
        const rows = sortedList.map((item: any) => {
            const row: any = {};

            visibleHeaders.forEach((h: ExportHeader) => {
                const key = h.text;
                const value = item[h.value];
                row[key] = value;
            });

            return row;
        });

        // --- Crear fila de totales ---
        const totals: any = {};
        visibleHeaders.forEach((h: ExportHeader) => {
            totals[h.text] = "";
        });

        totals["Pallet id"] = this.TotalPallets;
        totals["Total cases"] = this.TotalCases;

        totals["Total pieces"] = this.stockItemsFiltered.reduce(
            (s: number, x: any) =>
                s + Number(x.totalCases) * Number(x.goodsPerCase || 1),
            0
        );

        totals["Weight"] = this.stockItemsFiltered.reduce(
            (s: number, x: any) => s + Number(x.weight || 0),
            0
        );

        rows.push(totals);

        return {
            headers: visibleHeaders.map((h: ExportHeader) => h.text),
            rows
        };
    }

    async SetLanguageText() {
        if (this.languageText === "") {
            let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
            let settingsCompany = SettingsCompany.Settings.InboundDetailLanguageText;
            let settingsCompanyApi = new SettingsCompanyApi("Outbounds");
            let setting : ISettingsCompany[] = await settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingsCompany);
            if (setting.length === 0) {
                this.languageText = "Language";
            } else {
                this.languageText = setting[0].value;
            }
        }
    }

    get goodCodes(): string[] {
        return uniq(
            this.StockList
            .map(b => ((b.goodCode === null || b.goodCode === undefined) ? '' : String(b.goodCode)).trim())
            .filter(x => x !== '')
        );
    }

    get languages(): string[] {
        // Si el scanner está activo, en realidad filtramos por idPalletCustomer (Merken nummer)
        if (this.ScannerActive) {
            return uniq(
                this.StockList
                .filter(b => b.idPalletCustomer !== null && b.idPalletCustomer !== "")
                .map(b => b.idPalletCustomer)
            );
        }

        return uniq(
            this.StockList
            .filter(b => b.language !== null && b.language !== "")
            .map(b => b.language)
        );
    }

    get palletIds(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.idPallet !== null)
            .map(b => b.idPallet)
        );
    }

    getRowKey(item: IStock): string {
        return [
            item.id || '',
            item.idPallet || '',
            item.idInbound || '',
            item.idInboundDeliveryNoteDetail || '',
            item.idGood || '',
            item.idWarehouse || '',
            item.codeInbounds || ''
        ].join('|');
    }

    get showEditDialog() { return this.selectedStockList.length > 0; }

    get TotalCases() {
        return this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
    }

    isItemSelected(item: IStock): boolean {
        const key = this.getRowKey(item);
        return this.selectedStockList.some(s => this.getRowKey(s) === key);
    }

    GetValueDocumentation(documentationNeeded : boolean) {
        if (documentationNeeded !== null && documentationNeeded !== undefined) {
            if (documentationNeeded.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }

        return 'No';
    }

    get TotalPallets() {
        if (this.groupByActive) {
            return this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.palletsAmount), 0);
        } else {
            return this.stockItemsFiltered.length;
        }
    }

    get WarehouseListSort() {
        return [...this.WarehouseList].sort((n1, n2) => {
            if (n1.name > n2.name) return 1;
            if (n1.name < n2.name) return -1;
            return 0;
        });
    }

    getFiltered(items: IStock[]) {
        this.tableSortedItems = items; // <-- ahora sí guardamos el orden real
    }

    getStock() {
        this.$emit('onChangeWarehouse', this.warehouseSelected);
    }

    @Watch('warehouseSelected')
    onChangeWarehouseSelected() {
        this.groupByActive = false;
    }

    @Watch('groupByActive')
    onChangeGroupByActive() {
        if (this.warehouseSelected.length === 0) {
            this.showMessageWarning("Please select a warehouse");
        } else {
            this.$emit('groupByPallet', this.warehouseSelected, this.groupByActive);
        }
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    get bestBeforeDates() : Date[] {
        return uniq(
            this.StockList
            .filter(b => b.bestBeforeDate !== null)
            .map(b => b.bestBeforeDate)
        );
    }

    get dateIns() : Date[] {
        return uniq(
            this.StockList
            .filter(b => b.dateIn !== null)
            .map(b => b.dateIn)
        );
    }
   
    get warehouseNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.warehouseName !== null)
            .map(b => b.warehouseName)
        );
    }

    get inboundCodes() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.codeInbounds !== null)
            .map(b => b.codeInbounds)
        );
    }

    get inboundCodeDestinations() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.codeDestination !== null)
            .map(b => b.codeDestination)
        );
    }

    get customerNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.customerName !== null)
            .map(b => b.customerName)
        );
    }

    get goodNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.goodName !== null)
            .map(b => b.goodName)
        );
    }

    get locationNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.location !== null)
            .map(b => b.location)
        );
    }

    get palletNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.listPalletName !== null)
            .map(b => b.listPalletName)
        );
    }

    get companySourceNames() : string[] {
        return uniq(
            this.StockList
            .filter(b => b.companySourceName !== null)
            .map(b => b.companySourceName)
        );
    }

    get stockItemsFiltered() : IStock[] {
        let filteredList = this.StockList;

        if (this.inboundCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeFilter.includes(b.codeInbounds));
        }
        if (this.inboundCodeDestinationFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeDestinationFilter.includes(b.codeDestination));
        }
        if (this.customerFilter.length > 0) {
            filteredList = filteredList.filter(b => this.customerFilter.includes(b.customerName));
        }
        if (this.goodFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodFilter.includes(b.goodName));
        }
        if (this.locationFilter.length > 0) {
            filteredList = filteredList.filter(b => this.locationFilter.includes(b.location));
        }
        if (this.palletFilter.length > 0) {
            filteredList = filteredList.filter(b => this.palletFilter.includes(b.listPalletName));
        }
        if (this.warehouseNameFilter.length > 0) {
            filteredList = filteredList.filter(b => this.warehouseNameFilter.includes(b.warehouseName));
        }
        if (this.bestBeforeDateFilter.length > 0) {
            filteredList = filteredList.filter(b => this.bestBeforeDateFilter.includes(b.bestBeforeDate));
        }
        if (this.dateInFilter.length > 0) {
            filteredList = filteredList.filter(b => this.dateInFilter.includes(b.dateIn));
        }
        if (this.companySourceNamesFilter.length > 0) {
            filteredList = filteredList.filter(b => this.companySourceNamesFilter.includes(b.companySourceName));
        }
        if (this.palletIdFilter.length > 0) {
            filteredList = filteredList.filter(b => this.palletIdFilter.includes(b.idPallet));
        }
        if (this.goodCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodCodeFilter.includes(b.goodCode));
        }

        if (this.languageFilter.length > 0) {
            if (this.ScannerActive) {
                filteredList = filteredList.filter(b => this.languageFilter.includes(b.idPalletCustomer));
            } else {
                filteredList = filteredList.filter(b => this.languageFilter.includes(b.language));
            }
        }
        return filteredList;
    }

    getBestBeforeStatus(dateStr: any): "expired" | "soon" | "normal" {
        if (!dateStr) return "normal";

        const today = moment().startOf("day");
        let date: moment.Moment;

        // 🔹 Si viene como Date (objeto), lo tratamos directo
        if (dateStr instanceof Date) {
            date = moment(dateStr).startOf("day");
        } else if (typeof dateStr === "string") {
            const trimmed = dateStr.trim();

            // Intentamos con varios formatos comunes
            date = moment(trimmed, ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", moment.ISO_8601], true)
            .startOf("day");
        } else {
            // Tipo raro → lo ignoramos
            return "normal";
        }

        if (!date.isValid()) {
            console.warn("Invalid bestBeforeDate:", dateStr);
            return "normal";
        }

        // 🟥 Caducado (antes de hoy)
        if (date.isBefore(today)) {
            return "expired";
        }

        // 🟨 A punto de caducar: menos de 90 días desde hoy
        const diffDays = date.diff(today, "days");

        if (diffDays >= 0 && diffDays < 90) {
            return "soon";
        }

        // 🟦 Tranquilo, falta más de 3 meses
        return "normal";
    }
    getBestBeforeColor(status: "expired" | "soon" | "normal") {
        switch (status) {
            case "expired":
                return "red darken-2";
            case "soon":
                return "yellow darken-2";
            default:
                return "blue-grey lighten-2";
        }
    }

    clearAllFilters() : void {
        this.inboundCodeFilter = [];
        this.inboundCodeDestinationFilter = [];
        this.companySourceNamesFilter = [];
        this.customerFilter = [];
        this.goodFilter = [];
        this.locationFilter = [];
        this.palletFilter = [];
        this.bestBeforeDateFilter = [];
        this.dateInFilter = [];
        this.warehouseNameFilter = [];
        this.palletIdFilter = [];
        this.activeSelectAll = false;
        this.goodCodeFilter = [];
        this.languageFilter = [];
        this.clearSelection();
        this.showMessageInfo("All filters have been deselected");
    }

    select(item: IStock) {
        const itemKey = this.getRowKey(item);
        const idx = this.selectedStockList.findIndex(s => this.getRowKey(s) === itemKey);

        if (idx === -1) {
            this.selectedStockList.push(item);

            if (!this.selectedStockListOrderBySelection.some(s => this.getRowKey(s) === itemKey)) {
                this.selectedStockListOrderBySelection.push(item);
            }
        } else {
            this.selectedStockList.splice(idx, 1);

            const idxOrder = this.selectedStockListOrderBySelection.findIndex(s => this.getRowKey(s) === itemKey);
            if (idxOrder !== -1) {
                this.selectedStockListOrderBySelection.splice(idxOrder, 1);
            }

            if (this.selectedStockList.length === 0) {
                this.activeSelectAll = false;
                this.activeDeselectAll = false;
            }
        }
    }

    selectAll(active: boolean) {
        this.clearSelection();

        if (active) {
            const ordered = (this.tableSortedItems && this.tableSortedItems.length > 0)
                ? this.tableSortedItems
                : this.stockItemsFiltered;

            ordered.forEach(item => {
                this.selectedStockList.push(item);
                this.selectedStockListOrderBySelection.push(item);
            });
        }
    }

    deselectAll() {
        this.clearSelection();
        this.activeSelectAll = false;
        this.activeDeselectAll = false;
    }

    clearSelection() {
        this.selectedStockList = [];
        this.selectedStockListOrderBySelection = [];
    }

    openEditorPalletType(item: IStock) {
        let index = this.PalletTypeList.findIndex(p => p.name === item.listPalletName);
        this.selectedPalletType = this.PalletTypeList[index];
    }

    saveLocationsStock () {
        confirm('Are you sure you want to update this number of pallets: ' + this.selectedStockList.length + ' ? Check that you have not selected more pallets than you want to update.') && this.saveLocationsStocks();
    }

    saveLocationsStocks() {
        if (this.location && this.location.trim() !== "") {
            let index = this.locationNames.findIndex(l => l === this.location);
            if (index > -1) {
                if (confirm("Pallets are already located at this location. Are you sure you want to save this location for the selected pallets?")) {
                    this.selectedStockList.forEach(l => {
                        l.location = this.location;
                    });

                    this.$emit('saveLocationsStock', this.selectedStockList);
                }
            } else {
                this.selectedStockList.forEach(l => {
                    l.location = this.location;
                });
                this.$emit('saveLocationsStock', this.selectedStockList);
            }
        }
        this.dialog = false;
    }

    savePalletTypesStock () {
        confirm('Are you sure you want to update this number of pallets: ' + this.selectedStockList.length + ' ? Check that you have not selected more pallets than you want to update.') && this.savePalletTypesStocks();
    }

    savePalletTypesStocks() {
        let index = this.PalletTypeList.findIndex(p => p.name === this.selectedPalletTypeName);
        this.selectedStockList.forEach(l => {
            l.idListPallet = this.PalletTypeList[index].id;
            l.listPalletName = this.PalletTypeList[index].name;
        });

        this.$emit('savePalletTypesStock', this.selectedStockList);
        this.dialogPalletType = false;
    }

    saveLocationsStockSingle(item: IStock) {
        const newLocation = this.editingLocationValue ? this.editingLocationValue.trim() : "";
        const itemKey = this.getRowKey(item);

        if (newLocation !== "") {
            const duplicates = this.StockList.filter(
                l =>
                    this.getRowKey(l) !== itemKey &&
                    (l.location || "").toLowerCase() === newLocation.toLowerCase()
            );

            if (duplicates.length > 0) {
                if (confirm("Er zijn al pallets op deze locatie. Weet je zeker dat je deze locatie wilt opslaan voor de geselecteerde pallets?")) {
                    item.location = newLocation;
                    this.$emit('saveLocationStock', item);
                } else {
                    const original = this.StockListNoModifications.find(l => this.getRowKey(l) === itemKey);
                    const current = this.StockList.find(l => this.getRowKey(l) === itemKey);

                    if (original && current) {
                        current.location = original.location;
                    }
                }
            } else {
                item.location = newLocation;
                this.$emit('saveLocationStock', item);
            }
        } else {
            item.location = "";
            this.$emit('saveLocationStock', item);
        }

        this.editingLocationId = "";
        this.editingLocationValue = "";
    }

    savePalletTypeStockSingle(item: IStock) {
        let index = this.PalletTypeList.findIndex(p => p.name === item.listPalletName);
        item.idListPallet = this.PalletTypeList[index].id;
        this.$emit('savePalletTypeStock', item);
    }

    get LabelSortName () {
        return this.selectedStockList.sort((n1, n2) => {
            if (n1.goodName.toLowerCase() > n2.goodName.toLowerCase()) {
                return 1;
            }

            if (n1.goodName.toLowerCase() < n2.goodName.toLowerCase()) {
                return -1;
            }

            return 0;
        });
    }

    printLabels() {
        const orderedSelection = this.getSelectedItemsInTableOrder();

        if (orderedSelection.length > 0) {
            if (this.ScannerActive) {
                this.$emit('printLabelsForScanner', orderedSelection);
            } else {
                this.$emit('printLabels', orderedSelection);
            }
        } else {
            this.showMessageWarning("Pallet selection is required before labels can be printed.");
        }
    }
    printStock() {
        let ordered: IStock[];

        if (this.groupByActive) {
            // 🟦 1) Sacamos TODOS los idPallet visibles aunque estén agrupados
            this.$emit('printStockGrouped', this.selectedFormatToPrint, this.warehouseNameFilter, this.dateInFilter, this.bestBeforeDateFilter, this.locationFilter, this.customerFilter, this.inboundCodeFilter, this.inboundCodeDestinationFilter, this.goodFilter, this.companySourceNamesFilter);
            return;
        } else {
            // 🟩 SIN groupBy: usar el orden real de la tabla
            ordered = this.tableSortedItems.length > 0
                ? this.tableSortedItems
                : this.stockItemsFiltered;
        }

        // 🟦 3) Generar la exportación normal
        const exportData = this.buildExportData(ordered);

        this.$emit("printStockNew", exportData);
    }
   
    getSelectedItemsInTableOrder(): IStock[] {
        const ordered = (this.tableSortedItems && this.tableSortedItems.length > 0)
            ? this.tableSortedItems
            : this.stockItemsFiltered;

        const selectedKeys = new Set(this.selectedStockList.map(s => this.getRowKey(s)));

        const orderedSelected = ordered.filter(s => selectedKeys.has(this.getRowKey(s)));

        const orderedSelectedKeys = new Set(orderedSelected.map(s => this.getRowKey(s)));
        const notVisibleSelected = this.selectedStockList.filter(s => !orderedSelectedKeys.has(this.getRowKey(s)));

        return [...orderedSelected, ...notVisibleSelected];
    }

    save (item: IStock) {
        this.$emit('saveLocationStock', item);
    }

    cancel () {
    }

    open () {
    }

    close () {
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
